var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_32_WIP",
    "data-name": "32 WIP"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m115.9419 358.3305h59.3711a0 0 0 0 1 0 0v120.6285a22.074 22.074 0 0 1 -22.074 22.074h-15.2231a22.074 22.074 0 0 1 -22.074-22.074v-120.6285a0 0 0 0 1 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m336.6826 358.3305h59.3711a0 0 0 0 1 0 0v120.6285a22.074 22.074 0 0 1 -22.074 22.074h-15.2231a22.074 22.074 0 0 1 -22.074-22.074v-120.6285a0 0 0 0 1 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m329.95 119.7147-57.1941-99.0726a19.35 19.35 0 0 0 -33.5162 0l-57.1936 99.0726a19.35 19.35 0 0 0 16.7581 29.0244h114.3874a19.35 19.35 0 0 0 16.7584-29.0244zm-67.9517 1.0764a6 6 0 0 1 -12 0v-1.7793a6 6 0 0 1 12 0zm0-23.1772a6 6 0 0 1 -12 0v-42.647a6 6 0 0 1 12 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m339.687 209.6h-21.6616v43.324h21.6616a21.6619 21.6619 0 0 0 0-43.3238z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m434.049 148.87h-356.1023a45.4489 45.4489 0 0 0 -45.4489 45.449v118.5627a45.4488 45.4488 0 0 0 45.4489 45.4488h356.1023a45.4488 45.4488 0 0 0 45.4488-45.4488v-118.5627a45.4489 45.4489 0 0 0 -45.4488-45.449zm-198.3239 55.5168-13.0367 98.5708a7.5742 7.5742 0 0 1 -6.5024 6.566 7.8849 7.8849 0 0 1 -1.1118.0791 7.563 7.563 0 0 1 -6.9624-4.5723l-20.96-47.7271-20.8364 47.6915a7.644 7.644 0 0 1 -14.5825-2.0586l-13.0342-98.5494a6 6 0 0 1 11.8965-1.5732l10.9839 83.0483 17.3-39.5962a9.0193 9.0193 0 0 1 8.2563-5.4086h.0093a9.0215 9.0215 0 0 1 8.2593 5.3925l17.4306 39.691 10.9942-83.127a6 6 0 0 1 11.8965 1.5732zm41.1289 99.2132a6 6 0 0 1 -12 0v-100a6 6 0 0 1 12 0zm62.833-38.6762h-21.6616v38.6762a6 6 0 0 1 -12 0v-100a6 6 0 0 1 6-6h27.6616a33.6619 33.6619 0 0 1 0 67.3238z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWip);
export default __webpack_public_path__ + "static/media/wip.ec28e806696d6ffae3849c9447d2c38d.svg";
export { ForwardRef as ReactComponent };